// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../node_modules/rescript/lib/es6/belt_Option.js";

function sendEventToPartnerApp(event_name, source, banner_name, card_date, card_name, card_position, claim_button_status, param) {
  var metadata_last_primary_source = Belt_Option.getWithDefault(source, "");
  var metadata_banner_name = Belt_Option.getWithDefault(banner_name, "");
  var metadata_card_date = Belt_Option.getWithDefault(card_date, "");
  var metadata_card_name = Belt_Option.getWithDefault(card_name, "");
  var metadata_card_position = Belt_Option.getWithDefault(card_position, 0);
  var metadata_claim_button_status = Belt_Option.getWithDefault(claim_button_status, "");
  var metadata = {
    last_primary_source: metadata_last_primary_source,
    banner_name: metadata_banner_name,
    card_date: metadata_card_date,
    card_name: metadata_card_name,
    card_position: metadata_card_position,
    claim_button_status: metadata_claim_button_status
  };
  var eventInfo_attributes = {
    metadata: Belt_Option.getWithDefault(JSON.stringify(metadata), ""),
    current_screen: "rewards_and_recognition"
  };
  var eventInfo = {
    event_name: event_name,
    attributes: eventInfo_attributes,
    metrics: undefined
  };
  try {
    PartnerAppInterface.logAnalyticsEvent(Belt_Option.getWithDefault(JSON.stringify(eventInfo), ""));
    return ;
  }
  catch (exn){
    return ;
  }
}

export {
  sendEventToPartnerApp ,
  
}
/* No side effect */
